/* @flow */
import * as React from 'react';
import Box from 'components/Box.jsx';
import Container from 'components/Container.jsx';
import BoxHeader from 'components/BoxHeader.jsx';

import './RsvpView.scss';

function RsvpView() {
  return (
    <div>
      <div className="RsvpView-header" />
      <div className="RsvpView-content">
        <Container size="medium">
          <Box>
            <BoxHeader
              title="Activites have been discontinued on Remind."
              subtext="You can no longer RSVP to activities on Remind."
            />
          </Box>
        </Container>
      </div>
    </div>
  );
}

export default RsvpView;
